import {REQUEST_CLASS} from '../../Library/HtmxRequestState';
import {cloneButtonSpinner} from '../../Library/LoadingIndicator';

const CLICK_TRIGGERS = ['click', 'confirmed'];
const GATED_TRIGGERS = [...CLICK_TRIGGERS, 'submit'];

const busyButtonOf = ({elt, requestConfig}) => {
    const triggeringEvent = requestConfig.triggeringEvent;

    return triggeringEvent?.submitter ?? (CLICK_TRIGGERS.includes(triggeringEvent?.type) ? elt : null);
};

export const dropRepeatedRequest = event => {
    const {elt, triggeringEvent} = event.detail;

    if (GATED_TRIGGERS.includes(triggeringEvent?.type) && elt.classList.contains(REQUEST_CLASS)) {
        event.preventDefault();
    }
};

export const prepareButtonSpinner = event => {
    const button = busyButtonOf(event.detail);

    if (!button?.matches('button') || button.closest('.form-modal')) {
        return;
    }

    if (button.querySelector('.icon-swap, .button-spinner, img')) {
        return;
    }

    button.prepend(cloneButtonSpinner());
};
